export default "__VITE_ASSET__e013fb6a__"